/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description navbar actions
 */

import { createAction } from 'redux-actions'

import type { NAVBAR_MOBILE_LIST, NAVBAR_MOBILE_MAP } from '../../../constants/navbar'
import { SET_MOBILE_VIEW_TYPE, SET_NAVBAR_STICKY } from '../constants/index'

export const setMobileViewType = createAction<
  typeof NAVBAR_MOBILE_LIST | typeof NAVBAR_MOBILE_MAP,
  typeof SET_MOBILE_VIEW_TYPE
>(SET_MOBILE_VIEW_TYPE)

export const setNavbarSticky = createAction<boolean, typeof SET_NAVBAR_STICKY>(SET_NAVBAR_STICKY)
